import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as actions from '../actions/signOut';
var initialState = {
  isProcessing: true
};
export default reducerWithInitialState(initialState).case(actions.requestSignOut, function () {
  return {
    isProcessing: true
  };
}).case(actions.completeSignOut, function () {
  return {
    isProcessing: false
  };
});